import type { ProductItem } from '@app/_proto/Protos/products';
import { formatAmountForDisplay } from '@app/utils/utils';
import { YinYang } from 'mdi-material-ui';
import * as React from 'react';

export type KarmaPurchaseSelectionProps = {
    productSelection: ProductItem;
};

export default function KarmaPurchaseSelection({ productSelection }: KarmaPurchaseSelectionProps) {
    return (
        <div>
            <div className="mb-[12px] text-[14px]">Your selection</div>
            <div className="flex items-center justify-between">
                <div>
                    <div className="flex items-center space-x-[5px]">
                        <YinYang className="text-[#ffe000]" />
                        <span className="text-[15px] font-semibold">{productSelection.quantity.toLocaleString()}</span>
                    </div>
                    <p className="text-[14px] font-semibold text-[#888]">Golden Karma</p>
                </div>
                <div>
                    <span className="text-[20px] font-semibold">{formatAmountForDisplay(productSelection.price)}</span>
                </div>
            </div>
        </div>
    );
}
